import { render, staticRenderFns } from "./TabClinicLocation.vue?vue&type=template&id=9a981f58&scoped=true&"
import script from "./TabClinicLocation.vue?vue&type=script&lang=js&"
export * from "./TabClinicLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a981f58",
  null
  
)

export default component.exports